export const ContractNames = {
    management: 'Management',
    depositReceipt: 'DepositReceipt',
    redemptionReceipt: 'RedemptionReceipt',
    unityToken: 'UnityToken',
    XUnity: 'XUnity',
    XUnityTrinityPool: 'XUnityTrinityPool',
    mUnity: 'MUnity',
    MUnityTrinityPool: 'MUnityTrinityPool',
};
export const WithManagementContractNames = [
    ContractNames.depositReceipt,
    ContractNames.redemptionReceipt,
    ContractNames.unityToken,
];
//# sourceMappingURL=contracts.js.map